export class ClasseProcessual{
    id = 0;
    codItem = '';    
    codItemPai = '';
    tipoItem = '';
    nome = '';
    situacao = '';
    ativo = false;    
}